export default __webpack_public_path__ + "static/merchant-payment-solutions-1e9af8f93234eaebc8844da4abeaf522.png";